import React, { useRef } from "react";
import {
  ContentContainer,
  Text,
  Categories,
  Category,
  CategoryText,
  Row,
  ButtonNext,
  ButtonBack,
  Buttons,
} from "../Steps.styles";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  addItemState,
  categoriesData,
  selectedMarketplaceItemLoader,
  setCategory,
} from "../../../store/slices/marketplace/marketplaceSlice";
import openToast from "../../../utils/toast";
import AppLoader from "../../AppLoader";

const AddItemStepSubcategory = ({ onNext, onBack }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const categories = useSelector(categoriesData);
  const itemLoading = useSelector(selectedMarketplaceItemLoader);
  const addItem = useSelector(addItemState);
  const toastId = useRef(null);

  const selectedCategories = categories?.filter((c) =>
    addItem?.parentCategoryId?.includes(c.id),
  );

  const groupedSubcategories = selectedCategories
    ?.filter((c) => c.subcategories?.length > 0)
    .map((c) => ({ parent: c, subcategories: c.subcategories }));

  const allSubcategoryIds = groupedSubcategories?.flatMap((g) =>
    g.subcategories.map((s) => s.id),
  );

  const selectedSubcategoryIds =
    addItem?.categoryId?.filter((id) => allSubcategoryIds?.includes(id)) ?? [];

  const handleSubcategoryClick = (subcategoryId) => {
    const passThroughIds =
      selectedCategories
        ?.filter((c) => !c.subcategories?.length)
        .map((c) => c.id) ?? [];

    let newSelectedSubcategoryIds;
    if (selectedSubcategoryIds.includes(subcategoryId)) {
      newSelectedSubcategoryIds = selectedSubcategoryIds.filter(
        (id) => id !== subcategoryId,
      );
    } else {
      newSelectedSubcategoryIds = [...selectedSubcategoryIds, subcategoryId];
    }

    dispatch(setCategory([...passThroughIds, ...newSelectedSubcategoryIds]));
  };

  const handleNext = () => {
    if (!selectedSubcategoryIds.length) {
      openToast(
        toastId,
        "select-subcategory",
        "warning",
        t("please-select-a-subcategory"),
      );
      return;
    }
    onNext();
  };

  const handleBack = () => {
    onBack();
  };

  return (
    <>
      <ContentContainer>
        {!itemLoading && (
          <>
            {groupedSubcategories?.map(({ parent, subcategories }) => (
              <Row key={parent.id}>
                <Text>
                  {t("select-subcategory")} — {parent.name}:
                </Text>
                <Categories>
                  {subcategories.map((subcategory) => {
                    const isActive = addItem?.categoryId?.includes(
                      subcategory.id,
                    );
                    return (
                      <Category
                        key={subcategory.id}
                        $active={isActive}
                        onClick={() => handleSubcategoryClick(subcategory.id)}
                      >
                        <CategoryText $active={isActive}>
                          {subcategory.name}
                        </CategoryText>
                      </Category>
                    );
                  })}
                </Categories>
              </Row>
            ))}
          </>
        )}
        {itemLoading && <AppLoader size={20} />}
      </ContentContainer>
      {itemLoading === false && (
        <Buttons>
          <ButtonBack onClick={handleBack}>{t("back")}</ButtonBack>
          <ButtonNext onClick={handleNext}>{t("next")}</ButtonNext>
        </Buttons>
      )}
    </>
  );
};

export default AddItemStepSubcategory;
